<bee-my-profile-small [template]="moi.settings.content.template"></bee-my-profile-small>    